import { render, staticRenderFns } from "./LayoutContentRendererDefault.vue?vue&type=template&id=bacfb03e"
import script from "./LayoutContentRendererDefault.vue?vue&type=script&lang=js"
export * from "./LayoutContentRendererDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports